/**
 * Accredited Investor Declaration — Section 4 qualification categories.
 * Keys must match backend ACCREDITED_QUALIFICATION_KEYS in agreement_pdf_personalize.py.
 */
export const ACCREDITED_QUALIFICATION_CATEGORIES = [
  {
    id: 'cat_1',
    label:
      'Bank, insurance company, registered investment company, BDC, or SBIC (Category 1)',
  },
  {
    id: 'cat_2',
    label: 'ERISA employee benefit plan with total assets > $5 million (Category 2)',
  },
  {
    id: 'cat_3',
    label:
      'Tax-exempt organization, corporation, or partnership with assets > $5 million (Category 3)',
  },
  {
    id: 'cat_4',
    label: 'Director, executive officer, or general partner of the issuer (Category 4)',
  },
  {
    id: 'cat_5',
    label: 'Entity in which all equity owners are Accredited Investors (Category 5)',
  },
  {
    id: 'cat_6',
    label:
      'Natural person with net worth > $1 million (excluding primary residence) (Category 6)',
  },
  {
    id: 'cat_7',
    label:
      'Natural person with income > $200,000 (or $300,000 joint) for 2+ years (Category 7)',
  },
  {
    id: 'cat_8',
    label: 'Trust with assets > $5 million, with sophisticated person directing purchases (Category 8)',
  },
  {
    id: 'cat_9',
    label: 'Entity owning investments > $5 million (Category 9)',
  },
  {
    id: 'cat_10',
    label: 'Holder of Series 7, 65, or 82 license in good standing (Category 10)',
  },
  {
    id: 'qualified_purchaser',
    label: 'Qualified Purchaser under the Investment Company Act of 1940',
  },
];

export const getAccreditedCategoryLabel = (categoryId) =>
  ACCREDITED_QUALIFICATION_CATEGORIES.find((c) => c.id === categoryId)?.label || categoryId;

export default ACCREDITED_QUALIFICATION_CATEGORIES;
